module.exports = __webpack_public_path__ + "img/youtube-link.3d4c4f10.jpeg";